import { TextSelection } from 'prosemirror-state'

export function validateCustomListNonEmptyDocument(tr, schema) {
  let needsFix = false
  if (tr.doc.textContent === '') {
    // The list doesn't work if the document has no text.  If the document has
    // any custom list items, we need to add a  space to the document.  I
    // suspect this is caused by a bug in the prosemirror library, or there's
    // something I'm missing here.
    let hasCustomListItem = false
    let lastParagraph = null
    let lastParagraphPos = null
    tr.doc.descendants((node, pos) => {
      if (node.type.name === 'customListItem') {
        hasCustomListItem = true
        lastParagraph = null
        lastParagraphPos = null
      } else if (node.type.name === 'paragraph') {
        lastParagraph = node
        lastParagraphPos = pos
      } else {
        lastParagraph = null
        lastParagraphPos = null
      }
      return false
    })

    // But still, we only care about this if there's a custom list item
    // in the document
    if (hasCustomListItem) {
      if (!lastParagraph) {
        tr.insert(
          tr.doc.content.size,
          schema.nodes.paragraph.create({}, [schema.text(' ')]),
        )
        needsFix = true
      } else if (lastParagraph.content.size === 0) {
        const { anchor, head } = tr.selection
        console.warn('Fixing empty paragraph')
        tr.replaceWith(
          lastParagraphPos,
          lastParagraphPos + lastParagraph.nodeSize,
          schema.nodes.paragraph.create({}, [schema.text(' ')]),
        )
        tr.setSelection(TextSelection.create(tr.doc, anchor, head))
        needsFix = true
      }
    }
  }
  return needsFix
}
